import React from 'react';
import { graphql } from 'gatsby';
import { Layout } from '../components/layout';
import { Articles } from '../components/articles';
import { StrapiNode } from '../models/strapi';
import { IArticle } from '../models/article';
import { ISeo } from '../models/seo';

interface IndexProps {
  data: {
    strapiHomepage: {
      hero: {
        title: string;
      };
      seo: ISeo;
    };
    articles: {
      edges: StrapiNode<IArticle>[];
    };
  };
}

const IndexPage: React.FC<IndexProps> = ({ data }) => {
  return (
    <Layout seo={data.strapiHomepage.seo}>
      <div className="homepage">
        <div className="homepage__content">
          <h1>{data.strapiHomepage.hero.title}</h1>
          <Articles articles={data.articles.edges} />
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query HomepageQuery($blogStatuses: [String]) {
    strapiHomepage {
      hero {
        title
      }
      seo {
        metaTitle
        metaDescription
        shareImage {
          url
        }
      }
    }
    articles: allStrapiArticle(
      filter: { status: { in: $blogStatuses } }
      sort: { fields: publishedAt, order: DESC }
    ) {
      edges {
        node {
          strapiId
          slug
          title
          childStrapiArticleContent {
            childMarkdownRemark {
              timeToRead
            }
          }
          category {
            name
          }
          image {
            alternativeText
            localFile {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, width: 600, height: 300)
              }
            }
          }
          publishedAt
          author {
            name
            picture {
              alternativeText
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED, width: 30, height: 30)
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default IndexPage;
